import type { RouteObject } from "react-router";
import { Component } from "./utils";

export const frontendDashboardRoutes: RouteObject[] = [
	// { path: "workbench", element: Component("/pages/dashboard/workbench") },

	// 供应链 - 改为一级路由
	{ path: "commodity", element: Component("/pages/supplyChain/commodity") },
	{ path: "gjj", element: Component("/pages/supplyChain/gjj") },
	{ path: "hpp", element: Component("/pages/supplyChain/hpp") },
	{ path: "order", element: Component("/pages/supplyChain/order") },
	{ path: "settle", element: Component("/pages/supplyChain/settle") },
];
